/** YYYYMMDDHHMMにフォーマットする関数。 */
export const formatToYYYYMMDDHHMM = (dateString: string | null) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}/${month}/${day} ${hours}:${minutes}`;
};

/** 日時をフォーマットする関数。 */
export const formatDateTime = (dateString?: string | null) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${month}/${day} ${hours}:${minutes}`;
};

/** 時間をフォーマットする関数。 */
export const formatTime = (dateString: string | null) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

/** 有無に変換する関数。 */
export const convertToPresenceAbsence = (presence?: boolean | null): string => {
  if (presence === true) return 'あり';
  if (presence === false) return 'なし';
  return '';
};

/** 数値を文字列に変換する関数。 */
export const convertNumberToString = (value?: number | null): string => {
  if (value === undefined || value === null) return '';
  return String(value);
};
